import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MailboxInvitationRefreshersStorage {
    private invitationAnsweredRefresher = new Subject<boolean>();

    constructor() { }

    refreshAnswer(isUpdate: boolean) {
        this.invitationAnsweredRefresher.next(isUpdate);
    }

    listenAnswerRefresher(): Observable<boolean> {
        return this.invitationAnsweredRefresher.asObservable();
    }
}
